import type { LocationDescriptor } from 'history';

export interface LoginFormControllerData {
  joinLink?: LocationDescriptor;
  onSuccessfulLogin?: () => void;
}

export interface LoginFormControllerProps extends LoginFormControllerData {}
